module.exports = __webpack_public_path__ + "img/svg/background-user-rankings.02c75feed3337bf1da4119507466461e.svg";